import React from "react";
import { formatDisplayWeight } from "../utils/wasteRecords.utils";
import { WasteTotals } from "../types/wasteRecords.types";

/** The Target/Total readout rendered in the card header's right-hand slot. */
export const WasteHeaderTotals: React.FC<{ totals: WasteTotals }> = ({ totals }) => {
  const { totalKg, targetKg, displayUnit, overTarget } = totals;

  return (
    <>
      {targetKg > 0 && (
        <span className="tw-text-[10px] tw-font-mono tw-text-muted-foreground">
          Target:{" "}
          <span className="tw-text-foreground">
            {formatDisplayWeight(targetKg, displayUnit)} {displayUnit}
          </span>
        </span>
      )}
      <span
        className={`tw-text-xs tw-font-mono ${
          overTarget ? "tw-text-destructive tw-font-semibold" : "tw-text-muted-foreground"
        }`}
      >
        Total: {formatDisplayWeight(totalKg, displayUnit)} {displayUnit}
      </span>
    </>
  );
};

/** The over-target warning rendered below the header row. */
export const WasteOverTargetWarning: React.FC<{ totals: WasteTotals }> = ({ totals }) => {
  const { targetKg, displayUnit, overTarget } = totals;
  if (!(targetKg > 0 && overTarget)) return null;

  return (
    <p className="tw-text-[10px] tw-text-destructive tw-mt-1">
      Total exceeds the Waste / Side Stream amount specified in the process (
      {formatDisplayWeight(targetKg, displayUnit)} {displayUnit}).
    </p>
  );
};
